import {
  ApolloClient,
  defaultDataIdFromObject,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { getToken } from "./token";

const uri =
  process.env.REACT_APP_GRAPHQL_ENDPOINT || "https://ats.karjoo.plus/graphql";

const logoutLink = onError(({ graphQLErrors }) => {
  const token = getToken();

  const permissionError = graphQLErrors
    ? graphQLErrors.some(({ extensions }: any) => {
        if (!extensions) {
          return false;
        }

        return extensions.exception.errcode === "42501";
      })
    : false;

  if (token && permissionError) {
    window.location.href = "/logout";
  }
});

const httpLink = new HttpLink({ uri });

const authLink = setContext((_, { headers }) => {
  const token = getToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `token ${token}` : "",
    },
  };
});

const cache = new InMemoryCache({
  dataIdFromObject: (object) =>
    (object as { nodeId?: string }).nodeId || defaultDataIdFromObject(object),
});

const link = authLink.concat(httpLink);

export const client = new ApolloClient({
  link: logoutLink.concat(link),
  cache,
});
